import React from 'react';
import Carousel from "../components/Carousel";
import '../home.css';

export default function Home() {
  return (
    <>
      <div className="main-content-1">
        <div className="main-content-left">
          <h1><span>Stay ahead of the curve</span> with our&nbsp;
            <span className="highlight">IEEE Spectrum API </span>
          </h1>
          <p>
            Our API provides developers and students with access to the latest news and articles from the&nbsp;
            <span>IEEE Spectrum website</span>, allowing you to easily integrate this data
            into your own websites, web applications or mobile apps. With a range of data available,
            our API <span className="highlight">is perfect for anyone looking to stay on top of
              the latest developments in the world of engineering and technology.</span></p>
        </div>
        <img src="./images/programming.svg" classname="programming" alt="" />
      </div>

      <div className="parallax-container">
        <div className="fade-in-element">
          <h1>2100 ms</h1>
          <p>Latency based on multiple tests</p>
        </div>
        <div className="fade-in-element">
          <h1>8.1 / 10</h1>
          <p>Popularity on RapidAPI Hub</p>
        </div>
        <div className="fade-in-element">
          <h1>100%</h1>
          <p>Succes Rate on API Calls</p>
        </div>
      </div>

      <div className="main-content-2">
        <img src="./images/prices.svg" alt="prices icon" />
        <p>
          The API has been designed to make integrating <span className="highlight">IEEE Spectrum</span> news and articles into your project as simple
          as possible. With an easy-to-use endpoint and comprehensive documentation, you can start accessing and using
          this data in no time. And with the help of the <span className="premium">RapidAPI platform</span> you can now test our API with almost <span className='underlined'>unlimited requests</span> for <span className="free">FREE</span> !
        </p>
      </div>
      <p className="carousel-content">Enhance your website and seamlessly integrate top-quality
        news and articles from IEEE Spectrum, available through our API just like the card components below...</p>
      <h1 className="possibilities">The possibilities are trully limitless!</h1>
      <Carousel />
      <div className='main-content-3'>
        <div>
          <h1>Help us Improve Our API with <span>Your</span> Feedback and Ideas</h1>
          <p>
            In order to further improve our products and provide the best possible experience
            for our users, we kindly ask you to also take a few moments and complete our
            &nbsp;<a href='https://docs.google.com/forms/d/e/1FAIpQLSeeHiTo_SifkZWPpcE4hCXDSdE67fwHUYvNDFqZPbqRWTA0Kg/viewform' target="_blank" rel="noopener noreferrer" className='form'>Google Forms questionnaire</a>.
            Your feedback and suggestions are extremely valuable to us and will help us shape the future of our API.
            Additionally, we encourage you to reach out to us at <a href="https://mail.google.com/mail/u/0/?tab=rm&ogbl#inbox?compose=GTvVlcSBptCMvdNTNvkGdnVjkXNtLGXbjXwfgjpCxMTZXPLKnZlwRhFRrzSnhXmcSmprrlMhhQWXr" target="_blank" rel="noopener noreferrer">
              christopher.kormpos@gmail.com</a>&nbsp; with any further
            ideas, comments, or questions you may have. We are always open to collaborating with our users and
            taking their opinions into consideration.
          </p>
        </div>
        <img src="./images/google_docs.svg" alt="google docs icon" />
      </div>
      <div className='quest'>
        <span></span>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSeeHiTo_SifkZWPpcE4hCXDSdE67fwHUYvNDFqZPbqRWTA0Kg/viewform" className='button' target="_blank" rel="noopener noreferrer">
          <button>Answer the questionnaire here</button>
        </a>
        <span></span>
      </div>
    </>
  )
}